import {
  Box,
  Chip,
  Stack,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const THUMB_WIDTH = 84;

export const Root = styled("a")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  minHeight: 88,
  height: "100%",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  color: "inherit",
  textDecoration: "none",
  backgroundColor: theme.palette.background.paper,
  transition: theme.transitions.create(["border-color", "background-color"], {
    duration: theme.transitions.duration.shorter,
  }),

  "&:hover": {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));

export const Thumb = styled(Box)(({ theme }) => ({
  position: "relative",
  flexShrink: 0,
  width: THUMB_WIDTH,
  backgroundColor: theme.palette.action.hover,
  overflow: "hidden",
}));

export const ThumbImage = styled("img")(() => ({
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "cover",
}));

export const RelevanceChip = styled(Chip)(({ theme }) => ({
  position: "absolute",
  bottom: 4,
  left: 4,
  zIndex: 1,
  height: 16,
  borderRadius: 8,
  fontSize: 9,
  fontWeight: 600,

  "& .MuiChip-label": {
    padding: theme.spacing(0, 0.75),
  },
}));

export const ThumbPlaceholder = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  color: theme.palette.text.disabled,
}));

export const Body = styled(Stack)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  justifyContent: "center",
  gap: theme.spacing(0.75),
  padding: theme.spacing(1, 1.5),
}));

export const Title = styled(Typography)<TypographyProps>(() => ({
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  lineHeight: 1.3,
}));

export const Footer = styled(Stack)(() => ({
  minWidth: 0,
}));

export const Source = styled(Stack)(() => ({
  minWidth: 0,
}));

export const SourceLogo = styled("img")(() => ({
  flexShrink: 0,
  width: 16,
  height: 16,
  borderRadius: 4,
  objectFit: "contain",
}));
